import { Component } from "react";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import {
  loanStages,
  financingAssetTypes,
} from "../../../shared/dictionary/enums";

import RefreshButton from "../../../shared/ui/Refresh.Button";
import SoldLoansBulkUpload from "./Sold.Loans.Bulk.Upload.Component";
import loanSelling from "../../../services/soldLoans/connector";

class SoldLoansComponent extends Component {
  constructor(props) {
    super(props);

    let columns = this.getColumnConfig();

    this.state = { columns };
  }

  componentDidMount() {
    this.props.getSoldCandidatesLoans();
  }

  render() {
    return (
      <div className="loans-layout body-height content-padding">
        <RefreshButton onRefreshClick={this.props.getSoldCandidatesLoans} />
        <h3>Sold Loans:</h3>
        {!this.props.soldLoans.fetched ? (
          <div> Loading... </div>
        ) : (
          <div>
            <br />
            <TableNew
              {...this.props}
              columns={this.state.columns}
              items={this.props.soldLoans.data}
              actionColumnWidth={260}
              tableKey={"SoldLoans-Main"}
              selectId={"Id"}
            />
            <SoldLoansBulkUpload {...this.props} />
          </div>
        )}
      </div>
    );
  }

  getColumnConfig = () => {
    return [
      {
        key: "AccountId",
        label: "Get ssn",
        filter: false,
        visible: true,
        type: CELL_TYPES.ssn,
      },
      { key: "IntId", label: "Id", visible: true, type: CELL_TYPES.text },
      {
        key: "CreditStage",
        label: "Loan stage",
        visible: true,
        enumDict: loanStages,
        type: CELL_TYPES.enum,
      },
      {
        key: "DueAndOverdue.Amount",
        label: "Amount Due",
        visible: true,
        type: CELL_TYPES.money,
      },
      //{ key: 'DCAData.SoldAmount.Amount', label: 'Sold amount', visible: true, type: CELL_TYPES.money },
      { key: "OCR", label: "OCR", visible: true, type: CELL_TYPES.text },
      {
        key: "NominalInterest.Value",
        label: "Interest",
        visible: true,
        type: CELL_TYPES.percentage,
      },
      {
        key: "TotalPaid.Amount",
        label: "Paid amount",
        visible: true,
        type: CELL_TYPES.money,
      },
      /** old rows */
      {
        key: "CreditType",
        label: "Asset Type",
        visible: false,
        enumDict: financingAssetTypes,
        type: CELL_TYPES.enum,
      },
      {
        key: "IssueDate",
        label: "Issue date",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "TerminationStatusChange",
        label: "Termination Status Change",
        visible: true,
        type: CELL_TYPES.date,
      },
    ];
  };
}

export default loanSelling(SoldLoansComponent);
